import {TaskCreationSingleVoyage} from "@containers/singleVoyage/tasks/types";
import {IWayPointCreationSingleVoyage, IWayPointSingleVoyage} from "@containers/singleVoyage/types/point";

/**
 * Translates local stop ids into real ones after the voyage has been saved.
 *
 * The matching key is the stop's INDEX in the local array, because that is what
 * buildCreationWayPointsByPointsWithCorrection puts into plannedOrdinal when
 * sending to the backend. The local point's own plannedOrdinal will not do: new
 * points are created with plannedOrdinal = 0, so several of them would share a key.
 */
export const addDatabaseWaypointsIdsToTasksMutateSingleVoyage = ({
                                                                     tasks,
                                                                     pointsDatabase,
                                                                     pointsLocal,
                                                                 }: {
    pointsDatabase: (IWayPointCreationSingleVoyage | IWayPointSingleVoyage)[],
    pointsLocal: IWayPointCreationSingleVoyage[],
    tasks: TaskCreationSingleVoyage[],
}): TaskCreationSingleVoyage[] => {
    if (!tasks?.length) {
        return []
    }

    const map: Record<string, number> = {}

    pointsLocal?.forEach((point, index) => {
        const pointDatabase = pointsDatabase?.find((item) => item?.plannedOrdinal === index)
        if (!pointDatabase || point?.id === undefined || point?.id === null) {
            return
        }
        map[point.id.toString()] = pointDatabase.id
    })

    const transform = (waypointIds: number[] = []): number[] => {
        return waypointIds.map((id) => {
            const key = id?.toString()
            // Matched - substitute the real id. Unmatched - leave it as is: it is
            // either already a real id, or the backend will say more than any guess
            // made on the frontend.
            return key in map ? map[key] : id
        })
    }

    /**
     * An empty stop list is not "remove them all", it is lost state. Such a request
     * used to wipe every execution of the task, so it never leaves the frontend.
     */
    const requireWaypoints = (waypointIds: number[], title: string): number[] => {
        if (!waypointIds?.length) {
            throw new Error(`Доручення «${title}» лишилось без зупинок — збереження скасовано`)
        }
        return waypointIds
    }

    return tasks.map((task) => ({
        ...task,
        waypointIds: requireWaypoints(transform(task?.waypointIds), task?.title),
        subtasks: task?.subtasks?.map((subTask) => ({
            ...subTask,
            waypointIds: requireWaypoints(transform(subTask?.waypointIds), subTask?.title),
        })) ?? [],
    }))
}
